import React, {useContext, useRef, useState} from 'react'
import {Button, message, Modal, Popconfirm} from "antd"
import DownloadTemplate from "./../actions/DownloadTemplate";
import {imporListCustomers} from "../../../../services/api/apListCustomers";
import parseToken from "../../../../helpers/parseToken";
import {ListCustomersContext} from "../../context/ListCustomersContext";

const ListCustomersFormModal = (props) => {
    const {showModal, toggleModal} = props
    const [item, setItem] = useState({})
    const [loading, setLoading] = useState(false)
    const [validate, setValidate] = useState({})
    const [error, setError] = useState('')
    const [file, setFile] = useState(null)
    const [fileError, setFileError] = useState('')
    const ListCustomersPageContext = useContext(ListCustomersContext)
    const {fetchListCustomers} = ListCustomersPageContext
    const info = parseToken()

    const inputRef = useRef(null);

    const _handleChangeInput = (e) => {
        const {name, value} = e.target

        setItem({
            ...item,
            [name]: value.trim()
        })
        setError('')
        delete validate[name]
    }

    function _uploadFile() {
        inputRef.current.click();
    }

    const _handleChangeFile = (e) => {
        setFileError('')
        const {files} = e.target
        const extension = files[0].name.replace(/.+\.(?=[^.]+$)/, '')
        if (extension !== 'xlsx' && files[0].name !== 'xlsx') {
            return setFileError('File upload phải có định dạng .xlsx. Vui lòng kiểm tra lại.')
        }
        setFile(files[0])
    }

    const handleCancel = () => {
        toggleModal()
    }

    const _validateData = () => {
        let validateForm = {}

        if (item.listName.trim() === '') {
            Object.assign(validateForm, {leadName: 'Tên danh sách là bắt buộc'})
        }

        if (file === null) {
            Object.assign(validateForm, {file: 'Tên danh sách là bắt buộc'})
        }

        setValidate(validateForm)

        return validateForm
    }

    const _resetInfo = () => {
        setItem({})
        setFile(null)
    }

    const _addNewListCustomer = async () => {
        setLoading(true)

        try {
            const validateCheck = _validateData()

            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)
                setError('Dữ liệu không hợp lệ')

                return false
            }

            const formData = new FormData()
            formData.append('file', file)
            const response = await imporListCustomers(item.listName, info.sub || 'dongnguyen', formData)
            const {success} = response
            if (success !== '1') {
                setLoading(false)

                return message.error("Thêm danh sách Customers không thành công.")
            }

            setLoading(false)
            message.success("Thêm danh sách Customers thành công.")
        } catch (e) {
            message.error(e.message)
        }
    }

    const onSave = async () => {
        const response = await _addNewListCustomer()

        if (response !== false) {
            if (typeof fetchListCustomers === 'function') {
                await fetchListCustomers()
            }
            handleCancel()
        }
    }

    const onSaveAndNew = async () => {
        const response = await _addNewListCustomer()
        if (response !== false) {
            if (typeof fetchListCustomers === 'function') {
                await fetchListCustomers()
            }
            await _resetInfo()
        }
    }

    return <>
        <Modal
            title="Thêm mới Danh sách khách hàng"
            className="ModalCustom2 FormAdd"
            maskClosable={false}
            visible={showModal}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu và tạo mới?" onConfirm={onSaveAndNew}
                                okText="Yes" cancelText="No">
                        <Button key="submit2" loading={loading}>
                            Save & New
                        </Button>
                    </Popconfirm>
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu?" onConfirm={onSave} okText="Yes"
                                cancelText="No">
                        <Button key="submit" type="primary" loading={loading}>
                            Save
                        </Button>
                    </Popconfirm>
                </div>
            ]}
        >
            <div className="FormAddNew">
                <div className="FieldItem">
                    <label className="Label" htmlFor="listName">
                        Tên Danh sách:
                        <span className="Required">*</span>
                    </label>
                    <input
                        id="listName"
                        value={item.listName || ''}
                        type="text"
                        name="listName"
                        placeholder="Tên Danh sách"
                        onChange={_handleChangeInput}
                    />
                    {
                        validate.leadName && <span className="Error text-danger">{validate.leadName}</span>
                    }
                </div>
            </div>
            <div className="FormImport">
                <div className="importFileExcel mb-2">
                    <Button onClick={_uploadFile} type="primary" className="mr-2">Select a file</Button>
                    {file !== null && file.name}
                    {fileError && <span className="text-danger">{fileError}</span>}
                    <input
                        ref={inputRef}
                        type='file'
                        accept='.xlsx'
                        multiple={false}
                        onChange={_handleChangeFile}
                        style={{width: 100}}
                        id="inputUploadFile"
                        className='d-none'
                    />
                </div>
                <DownloadTemplate/>
                {error && <div className="text-danger mt-3">{error}</div>}
            </div>
        </Modal>
    </>
}

export default ListCustomersFormModal
